import { Button, Stack, Typography } from "@mui/material";
import { IconLock } from "src/components/icons-mui/lock";
import { InfoBox } from "../components/info-box";
import { useCertificateBoxContext } from "../context";

const CLOSED_DESCRIPTION_TEST_ID = "closed-description";
const CLOSED_BUTTON_TEST_ID = "closed-button";

export const CertificateBoxClosed = () => {
    const { dict, selectedCertificate: certificate } = useCertificateBoxContext();

    return (
        <>
            <Stack p={2} gap={2} display="flex" flexDirection="column">
                <InfoBox icon={<IconLock sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography data-test-Id={CLOSED_DESCRIPTION_TEST_ID} fontSize="sm">
                        {dict.closedTitle} {dict.closedDescription}
                    </Typography>
                </InfoBox>

                <Button
                    component="a"
                    href={certificate.closingClosedButtonUrl}
                    sx={{ width: "100%" }}
                    variant="contained"
                    color="green"
                    data-test-id={CLOSED_BUTTON_TEST_ID}
                >
                    {dict.closingClosedButton}
                </Button>
            </Stack>
        </>
    );
};
